import { Events } from 'global/constants';

class OrderHistoryAddProductsValidator {
	constructor() {
		this.orderHistoryReorderSection = document.querySelector(
			'[data-id="orderHistoryAddProducts"]',
		);
		const pubSub = window.od.events;
		pubSub.subscribe(
			Events.ADD_PRODUCTS_SELECTED_PRODUCTS_UPDATE,
			this.softValidateForm.bind(this),
		);
	}

	validateForm(data) {
		if (this.isValid(data)) {
			this.hideErrors();
			return true;
		}

		this.showErrors();
		return false;
	}

	softValidateForm(data) {
		if (this.isValid(data)) {
			this.hideErrors();
		}
	}

	isValid({ cartEntries }) {
		return cartEntries.some(({ quantity }) => quantity > 0);
	}

	hideErrors() {
		this.handleErrors(true);
	}

	showErrors() {
		this.handleErrors(false);
	}

	handleErrors(hide) {
		const classListAction = hide ? 'remove' : 'add';
		this.handleCheckboxErrors(this.orderHistoryReorderSection, classListAction);
		this.handleErrorElementErrors(classListAction);
	}

	handleCheckboxErrors(domContainer, classListAction) {
		const checkboxes = domContainer.querySelectorAll('[data-id="checkbox"]');
		Array.from(checkboxes).forEach(checkbox =>
			checkbox.classList[classListAction]('checkbox--has-error'),
		);
	}

	handleErrorElementErrors(classListAction) {
		const errorElement = document.querySelector(
			'[data-id="addProductsValidationErrorMsg"]',
		);
		errorElement.classList[classListAction](
			'order-history-add-products-validation-error-msg--has-errors',
		);
	}
}

export default OrderHistoryAddProductsValidator;
